// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { profileManager } from "../../../game_theme/flow_fb/flowController";
import { ComponentButton } from "../../framework/components/ComponentButton";
import { ComponentContainer } from "../../framework/components/ComponentContainer";
import { ComponentLabel } from "../../framework/components/ComponentLabel";
import { ComponentPicture } from "../../framework/components/ComponentPicture";
import { ComponentSpine } from "../../framework/components/ComponentSpine";
import { DialogBase } from "../../framework/dialogs/DialogBase";
import { tgfDialogs } from "../../framework/dialogs/tgfDialogs";
import { tgfHooks } from "../../framework/hooks/hooks";
import { tgfAudio } from "../../framework/tgfAudio";
import { tgfGraphics } from "../../framework/tgfGraphics";
import { tgfSettings } from "../../framework/tgfSettings";
import { DialogSettings, ExpSettings } from "../../settings/Settings";
import { s_black_square, s_portrait_empty, s_progressbar_bg, s_progressbar_fill_white, s_progressbar_fill_green, s_slingshot_back, s_slingshot_front, s_rank_emblem_wood, s_player_beams } from "../AssetDefinitions/ImageDefinitions";
import { feather_glimmer_loop, stars_level_up, a_ghostbar_fill, a_progressbar_fill } from "../AssetDefinitions/SoundDefinitions";
import { s_scope_sparkle } from "../AssetDefinitions/SpineDefinitions";
import { EventSystem } from "../Events/EventSystem";
import { Events } from "../Events/Events";
import { ExpManager } from "../ExpManager";
tgfSettings.dialogDefaults.ExpRewardDialog = {
    width: 800,
    height: 550,
    font: DialogSettings.rankFont,
    components: [],
    didWin: false,
    expBarWidth: 520,
    expBarHeight: 33,
    animationDelay: 0,
    nextEmblemGlowScaleFactor: 1,
};
export var ExpRewardDialog = function (properties) {
    "use strict";
    this.name = "ExpRewardDialog"; // The name of the dialog
    // Initialize properties
    this.initialize(tgfSettings.dialogDefaults.ExpRewardDialog);
    // Set user properties
    if (properties !== undefined) {
        this.setProperties(properties);
    }
    this.onDisconnect = this.close.bind(this, false);
    EventSystem.subscribe(Events.DISCONNECTED, this.onDisconnect);
    this.animatedExp = 0;
    this.preAnimatedExp = 0;
    this.startingExp = ExpManager.getExp();
    this.rank = ExpManager.getRank();
    this.gainedExp = this.didWin ? ExpSettings.expGain.win : ExpSettings.expGain.loss;
    ExpManager.gainExp(this.gainedExp);
};
// Inherit the base dialog
tgfDialogs.inherit(ExpRewardDialog, DialogBase);
ExpRewardDialog.prototype.doPrepare = function () {
    "use strict";
    this.transparentBlack = new ComponentButton({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2,
        xScale: Math.round(tgfGraphics.areaWidth / s_black_square.width) + 20,
        yScale: Math.round(tgfGraphics.areaHeight / s_black_square.height) + 20,
        alpha: 0,
        image: s_black_square,
        onClick: this.startFadeout.bind(this)
    });
    this.addComponent(this.transparentBlack);
    // Show the exp bar
    this.expBarContainer = new ComponentContainer({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2,
    });
    this.addComponent(this.expBarContainer);
    this.extraExpTextStartY = -100;
    this.extraExpText = new ComponentLabel({
        text: "+" + this.gainedExp + " XP",
        font: DialogSettings.expFont,
        y: this.extraExpTextStartY
    });
    this.expBarContainer.addComponent(this.extraExpText);
    var profileImage = profileManager.getInfo(tgfHooks.getPlayerID()).image;
    var profileScale = profileManager.scaler(profileImage, s_portrait_empty.width - 10);
    var borderScale = 1.35;
    var profileAngle = -0.3;
    this.playerFace = new ComponentPicture({
        image: profileImage,
        x: -270,
        y: -120,
        angle: profileAngle,
        xScale: borderScale * profileScale,
        yScale: borderScale * profileScale,
    });
    this.expBarContainer.addComponent(this.playerFace);
    this.playerFaceBorder = new ComponentPicture({
        image: s_portrait_empty,
        angle: profileAngle,
        x: 5,
        y: 5,
        xScale: borderScale,
        yScale: borderScale,
    });
    this.playerFace.addComponent(this.playerFaceBorder);
    this.expBarBackground = new ComponentPicture({
        image: s_progressbar_bg
    });
    this.expBarContainer.addComponent(this.expBarBackground);
    this.expBarPreFill = new ComponentPicture({
        image: s_progressbar_fill_white,
        createFromSlices: true,
        sliceMargins: 4,
        x: -this.expBarWidth / 2 - 3,
        y: -19,
    });
    this.expBarBackground.addComponent(this.expBarPreFill);
    this.expBarFill = new ComponentPicture({
        image: s_progressbar_fill_green,
        createFromSlices: true,
        sliceMargins: 4,
        width: ExpManager.getProgressPercentage(this.startingExp, this.rank) * this.expBarWidth,
        height: this.expBarHeight,
    });
    this.expBarPreFill.addComponent(this.expBarFill);
    this.currentSlingshotBack = new ComponentPicture({
        image: s_slingshot_back,
        x: -400,
        y: -200,
        xScale: 2,
        yScale: 2
    });
    this.expBarContainer.addComponent(this.currentSlingshotBack);
    this.currentSlingshotFront = new ComponentPicture({
        image: s_slingshot_front,
        xScale: 2,
        yScale: 2
    });
    this.currentSlingshotBack.addComponent(this.currentSlingshotFront);
    this.currentEmblem = new ComponentPicture({
        image: s_rank_emblem_wood,
        x: -325,
        y: -10
    });
    this.expBarContainer.addComponent(this.currentEmblem);
    this.playerRank = new ComponentLabel({
        text: this.rank.toString(),
        font: this.font,
        // These should be at x/y = 0, but something is off about label positioning.
        x: this.currentEmblem.containerRelativeX(),
        y: this.currentEmblem.containerRelativeY(),
    });
    this.currentEmblem.addComponent(this.playerRank);
    this.nextEmblemGlow = new ComponentPicture({
        image: s_player_beams,
        xScale: 0,
        yScale: 0,
        x: 310,
        y: -10
    });
    this.expBarContainer.addComponent(this.nextEmblemGlow);
    this.nextEmblem = new ComponentPicture({
        image: s_rank_emblem_wood,
        x: 310,
        y: -10
    });
    this.expBarContainer.addComponent(this.nextEmblem);
    this.nextSlingshotBack = new ComponentPicture({
        image: s_slingshot_back,
        y: -60,
    });
    this.nextEmblem.addComponent(this.nextSlingshotBack);
    this.nextSlingshotFront = new ComponentPicture({
        image: s_slingshot_front,
    });
    this.nextSlingshotBack.addComponent(this.nextSlingshotFront);
    // Show the reward
    this.rewardContainer = new ComponentContainer({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2,
    });
    this.addComponent(this.rewardContainer);
    this.rewardBeams = new ComponentPicture({
        image: s_player_beams,
        alpha: 0.9,
        xScale: 2,
        yScale: 2,
    });
    this.rewardContainer.addComponent(this.rewardBeams);
    this.rewardBeamsAngle = 0;
    this.rewardSlingshotBack = new ComponentPicture({
        image: s_slingshot_back,
        y: -100,
        xScale: 2,
        yScale: 2
    });
    this.rewardContainer.addComponent(this.rewardSlingshotBack);
    this.rewardSlingshotFront = new ComponentPicture({
        image: s_slingshot_front,
        xScale: 2,
        yScale: 2
    });
    this.rewardSlingshotBack.addComponent(this.rewardSlingshotFront);
    this.sparkles = new ComponentSpine({
        spineAnimation: s_scope_sparkle,
        y: 100,
        scale: 4,
        repeat: true
    });
    this.rewardSlingshotFront.addComponent(this.sparkles);
};
ExpRewardDialog.prototype.afterShow = function () {
    this.rewardContainer.hide();
    this.expBarContainer.hide();
};
ExpRewardDialog.prototype.goToReward = function () {
    this.rewardSlingshotBack.changeImage(ExpManager.getRankAssets(this.rank).back);
    this.rewardSlingshotFront.changeImage(ExpManager.getRankAssets(this.rank).front);
    this.rewardSlingshotPosDiff = this.rewardSlingshotBack.y - this.rewardContainer.y;
    this.rewardSlingshotBack.setScale(0, 0);
    this.rewardSlingshotBack.y = this.rewardContainer.y;
    this.rewardSlingshotFront.setScale(0, 0);
    // this.rewardSlingshotFront.y = this.rewardContainer.y;
    this.sparkles.bringToFront();
    var id = tgfAudio.play(feather_glimmer_loop);
    tgfAudio.setLooping(id, true);
    tgfAudio.play(stars_level_up);
    this.rewardContainer.show();
    this.expBarContainer.hide();
    this.expBarPaused = true;
    this.transparentBlack.onClick = this.goToExpBar.bind(this, true);
};
ExpRewardDialog.prototype.goToExpBar = function (pulseRank) {
    var thisRankAssets = ExpManager.getRankAssets(this.rank);
    this.currentSlingshotBack.changeImage(thisRankAssets.back);
    this.currentSlingshotFront.changeImage(thisRankAssets.front);
    this.currentEmblem.changeImage(thisRankAssets.emblem);
    this.playerFace.bringToFront();
    this.playerFaceBorder.bringToFront();
    this.expBarBackground.bringToFront();
    this.expBarPreFill.bringToFront();
    this.expBarFill.bringToFront();
    this.currentEmblem.bringToFront();
    this.playerRank.bringToFront();
    this.extraExpText.bringToFront();
    this.nextEmblemGlow.bringToFront();
    var nextRankAssets = ExpManager.getRankAssets(this.rank + 1);
    this.nextEmblem.changeImage(nextRankAssets.emblem);
    this.nextSlingshotBack.changeImage(nextRankAssets.back);
    this.nextSlingshotFront.changeImage(nextRankAssets.front);
    this.nextEmblemGlow.setScale(0, 0);
    tgfAudio.stop("game");
    this.rewardContainer.hide();
    this.expBarContainer.show();
    this.extraExpText.hide();
    this.expBarPaused = false;
    this.rankPreFilled = false;
    this.transparentBlack.onClick = this.startFadeout.bind(this);
    if (pulseRank) {
        this.currentEmblem.setScale(1.5, 1.5);
        this.playerRank.setScale(1.5, 1.5);
    }
};
ExpRewardDialog.prototype.startFadeout = function () {
    this.rewardContainer.hide();
    this.expBarContainer.hide();
    this.isFadingOut = true;
    tgfAudio.stop("game");
};
ExpRewardDialog.prototype.close = function () {
    this.hide();
    this.free();
    tgfAudio.stop("game");
    EventSystem.unsubscribe(Events.DISCONNECTED, this.onDisconnect);
    if (this.onClose) {
        this.onClose();
    }
};
ExpRewardDialog.prototype.handleEndStep = function (timePassed) {
    "use strict";
    ExpRewardDialog.uber.handleEndStep.call(this, timePassed);
    var self = this;
    if (this.animationDelay <= 0) {
        if (this.expBarPaused) {
            this.rewardBeamsAngle += (timePassed / 1000 * 2 * Math.PI) / 10;
            this.rewardBeams.setAngle(this.rewardBeamsAngle);
            if (this.rewardSlingshotBack.xScale < 2) {
                var scale = this.rewardSlingshotBack.xScale + timePassed / 1000 * 4;
                this.rewardSlingshotBack.setScale(scale, scale);
                this.rewardSlingshotBack.y = scale / 2 * this.rewardSlingshotPosDiff + this.rewardContainer.y;
                this.rewardSlingshotFront.setScale(scale, scale);
                // this.rewardSlingshotFront.y = scale / 2 * this.rewardSlingshotPosDiff + this.rewardContainer.y
            }
            else if (!this.startedSparks) {
                this.sparkles.setAnimation("sparkle_effect", function () {
                    console.log("DONE");
                });
                this.startedSparks = true;
            }
        }
        else {
            if (this.isFadingOut) {
                this.transparentBlack.setAlpha(this.transparentBlack.alpha - timePassed / 1000);
                if (this.transparentBlack.alpha <= 0) {
                    this.close();
                }
            }
            else if (this.transparentBlack.alpha < 0.7) {
                this.transparentBlack.setAlpha(this.transparentBlack.alpha + timePassed / 1000 * 1.4);
                if (this.transparentBlack.alpha >= 0.7) {
                    this.goToExpBar();
                    this.animationDelay = 500;
                }
            }
            else if (this.preAnimatedExp < this.gainedExp && !this.rankPreFilled && !this.hitNextRank) {
                var expGain = timePassed / 1000 * this.gainedExp * 1;
                if (!this.startedAudio) {
                    var id = tgfAudio.play(a_ghostbar_fill);
                    tgfAudio.setLooping(id, true);
                    this.startedAudio = true;
                }
                if (this.preAnimatedExp + expGain > this.gainedExp) {
                    this.preAnimatedExp = this.gainedExp;
                    this.extraExpText.show();
                    this.extraExpText.activate();
                    this.animationDelay = 500;
                    tgfAudio.stop("game");
                    this.startedAudio = false;
                }
                else {
                    this.preAnimatedExp += expGain;
                }
                var totalXp = this.startingExp + this.preAnimatedExp;
                if (totalXp >= ExpManager.getNeededExp(this.rank)) {
                    this.preAnimatedExp = 0;
                    this.rankPreFilled = true;
                    this.extraExpText.show();
                    this.extraExpText.activate();
                    this.animationDelay = 500;
                    tgfAudio.stop("game");
                    this.startedAudio = false;
                }
                else {
                    var percentage = ExpManager.getProgressPercentage(totalXp, this.rank);
                    var progressWidth = percentage * this.expBarWidth;
                    this.expBarPreFill.setDimensions(progressWidth, this.expBarHeight);
                }
            }
            else if (this.animatedExp < this.gainedExp && !this.hitNextRank) {
                var expGain = timePassed / 1000 * this.gainedExp * 0.75;
                if (!this.startedAudio) {
                    var id = tgfAudio.play(a_progressbar_fill);
                    tgfAudio.setLooping(id, true);
                    this.startedAudio = true;
                }
                if (this.animatedExp + expGain > this.gainedExp) {
                    this.animatedExp = this.gainedExp;
                    tgfAudio.stop("game");
                    this.startedAudio = false;
                }
                else {
                    this.animatedExp += expGain;
                }
                var totalXp = this.startingExp + this.animatedExp;
                if (totalXp >= ExpManager.getNeededExp(this.rank)) {
                    this.rank++;
                    this.gainedExp -= this.animatedExp;
                    this.animatedExp = 0;
                    this.startingExp = 0;
                    totalXp = 0;
                    this.expBarPreFill.setDimensions(0, this.expBarHeight);
                    tgfAudio.stop("game");
                    this.startedAudio = false;
                    var scaleBump = 1.5;
                    // this.nextEmblemGlow.setScale(this.nextEmblemGlowScaleFactor * scaleBump, this.nextEmblemGlowScaleFactor * scaleBump);
                    this.nextEmblem.setScale(scaleBump, scaleBump);
                    this.nextEmblemPosDiff = this.nextSlingshotBack.y - this.nextEmblem.y;
                    this.nextSlingshotBack.setScale(scaleBump, scaleBump);
                    this.nextSlingshotBack.y = this.nextEmblem.y + this.nextEmblemPosDiff * scaleBump;
                    this.nextSlingshotFront.setScale(scaleBump, scaleBump);
                    // this.nextSlingshotFront.y = this.nextEmblem.y + this.nextEmblemPosDiff * scaleBump;
                    this.hitNextRank = true;
                }
                else {
                    var percentage = ExpManager.getProgressPercentage(totalXp, this.rank);
                    var progressWidth = percentage * this.expBarWidth;
                    this.expBarFill.setDimensions(progressWidth, this.expBarHeight);
                }
                this.extraExpText.setPosition(this.extraExpText.x, this.extraExpText.y - timePassed / 5);
                var newAlpha = Math.max(this.extraExpText.alpha - timePassed / 750, 0);
                this.extraExpText.setAlpha(newAlpha);
                this.extraExpText.alpha = newAlpha;
            }
            else if (this.nextEmblem.xScale > 1) {
                var scale = this.nextEmblem.xScale - timePassed / 1000 / 2;
                this.nextEmblem.setScale(scale, scale);
                this.nextSlingshotBack.setScale(scale, scale);
                this.nextSlingshotBack.y = this.nextEmblem.y + this.nextEmblemPosDiff * scale;
                this.nextSlingshotFront.setScale(scale, scale);
                // this.nextSlingshotFront.y = this.nextEmblem.y + this.nextEmblemPosDiff * scale;
                if (scale < 1.4) {
                    this.nextEmblemGlow.setScale(this.nextEmblemGlowScaleFactor * scale, this.nextEmblemGlowScaleFactor * scale);
                }
                if (scale <= 1) {
                    setTimeout(function () {
                        var percentage = ExpManager.getProgressPercentage(self.gainedExp, self.rank);
                        var progressWidth = percentage * self.expBarWidth;
                        self.expBarFill.setDimensions(progressWidth, self.expBarHeight);
                        self.playerRank.setText(self.rank.toString());
                        self.goToReward();
                    }, 500);
                }
            }
            else if (this.currentEmblem.xScale > 1) {
                var scale = this.currentEmblem.xScale - timePassed / 1000 / 2;
                this.currentEmblem.setScale(scale, scale);
                this.playerRank.setScale(scale, scale);
            }
        }
    }
    else {
        this.animationDelay -= timePassed;
    }
};
